import {
  load as primaryNavigationLoad,
} from './PrimaryNavigation/primary-navigation';
import { load as quickSearchLoad } from './QuickSearch/quick-search-loader';
import {
  load as imageGalleryLoad,
} from './Widgets/ImageGallery/image-gallery-loader';
import {
  load as relatedVideosLoad,
} from './Widgets/RelatedVideos/related-videos-loader';

export function loadComponents() {
  primaryNavigationLoad();
  quickSearchLoad();
  imageGalleryLoad();
  relatedVideosLoad();
}
